/**
 * Maximum unseamed countertop section length, measured on the COUNTERTOP (not the base).
 * `guide-2026:199,203,208-212` — `only when the panel/panel section exceeds 88”`,
 * `Only if countertop/countertop section exceeds 88”`. `guide-2026:436` settles the
 * measurement basis against `moks-playbook:152-153`: measurements are taken by
 * countertop, not base. See `docs/breakpoint-rules.md`.
 */
export const MAX_UNSEAMED_SECTION_LENGTH = 88;

/**
 * Appliance categories that require a seam on GRANITE at any countertop size.
 * `guide-2026:213-216` — `All Grills (Grills, Flat-tops, Power Burners, C1DB, etc.)`,
 * `Farm Sink and Refreshment Center- required no matter countertop size`.
 * Side Burners are deliberately absent: `guide-2026:217` exempts C1SB unless size requires it.
 */
export const GRANITE_SEAM_CATEGORIES: Array<string> = ['Grills', 'Farmhouse Sinks', 'Refreshment Centers'];

/**
 * Appliance SKUs that require a seam on GRANITE at any countertop size but carry no
 * category of their own. `guide-2026:214` — `C1SLV (Power Burner/Asado Sleeve)- required
 * no matter countertop size`. C1SLV's catalog category is `Accessories`, so it can only be
 * matched by SKU.
 */
export const GRANITE_SEAM_SKUS: Array<string> = ['C1SLV', 'C3SLV'];

/** Appliance categories treated as a grill by the placement ladder's first rung. */
export const GRILL_CATEGORIES: Array<string> = ['Grills'];

/** Tolerance used when deciding whether a seam already sits at a position. 1/16". */
export const SEAM_POSITION_TOLERANCE = 0.0625;
